export const AppRouteNames = {
  home: {
    label: "ホーム",
    value: "home",
  },

  login: {
    label: "ログイン",
    value: "login",
  },
  logout: {
    label: "ログアウト",
    value: "logout",
  },
  recover: {
    label: "新規登録",
    value: "recover",
  },
  resetPassword: {
    label: "パスワード再設定",
    value: "reset_password",
  },
  register: {
    label: "新規登録",
    value: "register",
  },

  mockExam: {
    label: "模試",
    value: "mockExam",
  },

  mockExamDetail: {
    label: "模試・詳細",
    value: "mock_exam_detail",
  },

  pageNotFound: {
    label: "「ページが見つかりません」の画面",
    value: "page_not_found",
  },
  serverErrorPage: {
    label: "サーバーエラーページ",
    value: "server_error_page",
  },

  maintenance: {
    label: "メンテナンス",
    value: "maintenance",
  },

  userSettingDetail: {
    label: "ユーザー設定",
    value: "user_setting_detail",
  },
  userSettingEdit: {
    label: "ユーザー設定編集",
    value: "user_setting_edit",
  },
  userSettingChangeEmail: {
    label: "ユーザー設定のメール更新",
    value: "user_setting_change_email",
  },
  userSettingStudy: {
    label: "学習の設定",
    value: "user_setting_study",
  },
  study: {
    label: "学習トップ",
    value: "study",
  },
  studySubject: {
    label: "学習・科目ページ",
    value: "study_subject",
  },
  studyContents: {
    label: "学習・コンテンツ",
    value: "study_contents",
  },
  studyDiagnosis: {
    label: "診断テスト",
    value: "study_diagnosis",
  },
  studyWordPractice: {
    label: "単語練習",
    value: "study_word_practice",
  },
  studyWordQuiz: {
    label: "単語テスト",
    value: "study_word_quiz",
  },
  studyLevelPractice: {
    label: "レベル練習",
    value: "study_level_practice",
  },
  studyLevelQuiz: {
    label: "レベルテスト",
    value: "study_level_quiz",
  },
  studyTextExplanation: {
    label: "本文解説",
    value: "study_text_explanation",
  },
  vocabularyCategoryList: {
    label: "語彙カテゴリ一覧",
    value: "vocabulary_category_list",
  },
  vocabularyDetail: {
    label: "語彙一覧（カテゴリ）",
    value: "vocabulary_detail",
  },
  vocabularyPractice: {
    label: "語彙・練習",
    value: "vocabulary_practice",
  },
  vocabularyQuiz: {
    label: "語彙・テスト",
    value: "vocabulary_quiz",
  },
  mockExamQuiz: {
    label: "模試・出題",
    value: "mock_exam_quiz",
  },
  mockExamResult: {
    label: "模試・結果",
    value: "mock_exam_result",
  },
  more: {
    label: "その他",
    value: "more",
  },
  license: {
    label: "ライセンス情報",
    value: "license",
  },
  contentProvider: {
    label: "コンテンツの提供元情報",
    value: "content_provider",
  },
};
